/**
 * @generated SignedSource<<42a6dfb6cc098e19a312fc93e78b7ca9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SignupConfirmMutationInput = {
  clientMutationId?: string | null;
  code: string;
  token: string;
};
export type AuthSignupConfirmMutation$variables = {
  input: SignupConfirmMutationInput;
};
export type AuthSignupConfirmMutation$data = {
  readonly signupConfirm: {
    readonly __typename: "SignupConfirmError";
    readonly message: string;
  } | {
    readonly __typename: "SignupConfirmSuccess";
    readonly refreshToken: string;
    readonly token: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type AuthSignupConfirmMutation = {
  response: AuthSignupConfirmMutation$data;
  variables: AuthSignupConfirmMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "signupConfirm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "token",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "refreshToken",
            "storageKey": null
          }
        ],
        "type": "SignupConfirmSuccess",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "type": "SignupConfirmError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthSignupConfirmMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AuthSignupConfirmMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "44f52e596425432e91690922a5f1c43b",
    "id": null,
    "metadata": {},
    "name": "AuthSignupConfirmMutation",
    "operationKind": "mutation",
    "text": "mutation AuthSignupConfirmMutation(\n  $input: SignupConfirmMutationInput!\n) {\n  signupConfirm(input: $input) {\n    __typename\n    ... on SignupConfirmSuccess {\n      token\n      refreshToken\n    }\n    ... on SignupConfirmError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1455e5a880a55654eb5a56a8aa6e540";

export default node;
